module.exports = __webpack_public_path__ + "img/icon-yqjj.e85632f8.png";